import { render, staticRenderFns } from "./BusinessProfileForm.vue?vue&type=template&id=6099aa16&"
import script from "./BusinessProfileForm.vue?vue&type=script&lang=js&"
export * from "./BusinessProfileForm.vue?vue&type=script&lang=js&"
import style0 from "@/app/assets/style/onboarding-form.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports